import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { globalSnackBarConfig } from '@app/types/snack-bar.types';
import { LoggerType } from '@app/types/logger.types';
import { SnackBarItemComponent } from '@app/common/components/snack-bar-item/snack-bar-item.component';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private snackBar = inject(MatSnackBar);

  log(logType: LoggerType, message: string, title?: string): void {
    if (!logType || !message) {
      return;
    }

    const snackBarConfig = {
      ...globalSnackBarConfig,
      announcementMessage: message,
      data: {
        title: title || null,
        message: message,
        type: logType
      }
    };

    this.snackBar.openFromComponent(SnackBarItemComponent, snackBarConfig);
  }
}
